import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';

export class CustomDateAdapter extends NativeDateAdapter {
  // Override the format method
  override format(date: Date, displayFormat: Object): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}/${month}/${day}`; // Return the date in yyyy/mm/dd format
  }

  // Override the parse method (if needed)
  override parse(value: any): Date | null {
    if (typeof value === 'string') {
      const parts = value.split('/');

      // Handle MM/yyyy format
      if (parts.length === 2) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are zero-based
        return new Date(year, month); // Set to the first day of the month
      }

      if (parts.length === 3) {
        const year = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Months are zero-based
        const day = parseInt(parts[2], 10);
        return new Date(year, month, day);
      }
    }
    return null;
  }
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'input',
  },
  display: {
    dateInput: 'yyyy/MM/dd',
    monthYearLabel: 'YYYY/MM',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY/MM',
  },
};
